import React from 'react';
import {
  Box, Button, Typography,
} from '@mui/material';

type ErrorPageProps = {
  embedded?: boolean;
};

function ErrorPage({ embedded = false }: ErrorPageProps) {
  return (
    <Box sx={{
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      bgcolor: '#F6F5FA',
      position: 'relative',
      overflow: 'hidden',
      ...(embedded
        ? {
          flex: 1,
          minHeight: { xs: 'calc(100dvh - 140px)', md: 'min(70dvh, 560px)' },
          py: 3,
        }
        : {
          height: '100vh',
        }),
    }}
    >
      <Box
        component="img"
        src="/confi-left.svg"
        alt=""
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          left: '30vw',
          top: '20vh',
          width: 'clamp(80px, 12vw, 160px)',
          pointerEvents: 'none',
        }}
      />
      <Box
        component="img"
        src="/confi-right.svg"
        alt=""
        sx={{
          display: { xs: 'none', md: 'block' },
          position: 'absolute',
          right: '30vw',
          bottom: '20vh',
          width: 'clamp(60px, 10vw, 125px)',
          pointerEvents: 'none',
        }}
      />
      <Box>
        <img alt="Dog Cat Error Logo" height="140px" width="140px" src="/dog_cat.png" onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
      </Box>
      <Box>
        <Typography variant="h5" color="primary.700" align="center">Oops! Something went wrong</Typography>
      </Box>
      <Box
        sx={{
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
        }}
      >
        <Typography variant="subtitle1" color="primary.contrastLight" align="center">
          Reload the page or email us at support@petcademy.org if the issue continues
        </Typography>
        <Button onClick={() => window.location.reload()} sx={{ textTransform: 'none' }}>
          Reload Page
        </Button>
      </Box>
    </Box>
  );
}

export default ErrorPage;
